var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-base',{attrs:{"pacifier":false},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Sorry, something seems to have not worked correctly.")]},proxy:true},{key:"subtitle",fn:function(){return [_vm._v("Your information has still been passed on to your Unbundled Attorney.")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }